module.exports = __webpack_public_path__ + "img/logo.1acd6467.jpg";